import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_AD_GROUP_STICKY_COLUMNS,
  UPDATE_AD_GROUP_STICKY_COLUMNS,
} from "./actionTypes"

import {
  getAdgroupStickyColumnsSuccess,
  getAdgroupStickyColumnsError,
  updateAdgroupStickyColumnsSuccess,
  updateAdgroupStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* ongetAdgroupStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_ad_groups`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getAdgroupStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getAdgroupStickyColumnsError(error))
  }
}

function* onupdateAdgroupStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_ad_groups/${action?.payload?.user_column_preference_ad_group?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAdgroupStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateAdgroupStickyColumnsError(error))
  }
}

function* userAdGroupColumnPreferenceSaga() {
  yield takeEvery(GET_AD_GROUP_STICKY_COLUMNS, ongetAdgroupStickyColumns)
  yield takeEvery(UPDATE_AD_GROUP_STICKY_COLUMNS, onupdateAdgroupStickyColumns)
}

export default userAdGroupColumnPreferenceSaga;
